import MutationTypes from '@/store/constants/mutations';

export default (store) => (to, from, next) => {
  if (store.getters.isSignedIn) {
    next();
  } else {
    store.commit(MutationTypes.SET_LAST_UNAUTHORIZED_PATH, to.path);
    next('/login');
  }
};
